import instance from "../api-provider";
import billingInstance from "../api-billing";

export const fetchPracticeUsers = async (payload) => {
  try {
    let { data } = await instance({
      url: "/fetchPracticeUsers",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const addPracticeUser = async (payload) => {
  try {
    let { data } = await instance({
      url: "/fetchPracticeUsers",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const updatePracticeUser = async (payload) => {
  try {
    let { data } = await instance({
      url: "/updatePracticeUser",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const getPracticeList = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/provider/getPracticeList",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {}
};

export const addPractice = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/provider/addPractice",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    return {
      message: error?.response?.data?.error,
      code: error?.response?.status,
    };
  }
};

export const addPracticeLocationPractice = async (payload) => {
  try {
    let { data } = await instance({
      url: "/addPracticeLocation",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const editPracticeP = async (payload) => {
  try {
    let { data } = await instance({
      url: "/editPractice",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const getPracticeLocations = async (payload) => {
  try {
    let { data } = await instance({
      url: "/getPracticeLocations",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const getProviderListPractice = async (payload, token) => {
  try {
    let { data } = await billingInstance({
      url: "/getProviderList",
      data: payload,
      addPracticeId: false,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {}
};

export const addProviderPractice = async (payload, setErrorMessage, token) => {
  try {
    let { data } = await billingInstance({
      url: "/addProvider",
      data: payload,
      addPracticeId: false,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    if (
      error?.response?.data?.error?.includes("Provider.provider_npi_UNIQUE")
    ) {
      setErrorMessage("Provider NPI is already used.");
    } else setErrorMessage("Failed to add provider");
  }
};

export const updateProviderPractice = async (payload) => {
  try {
    let { data } = await instance({
      url: "/updateProvider",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {}
};

export const validatePracticeDetails = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "/provider/validatePracticeDetails",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("validatePracticeDetails", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const getPracticeClaimListAICodingOptimization = async (
  payload,
  token
) => {
  try {
    let { data } = await instance({
      url: "practice/getPracticeClaimListAICodingOptimization",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("getPracticeClaimListAICodingOptimization", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const getPracticeEncounterListAICodingOptimization = async (
  payload,
  token
) => {
  try {
    let { data } = await instance({
      url: "practice/getPracticeEncounterListAICodingOptimization",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("getPracticeEncounterListAICodingOptimization", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const getPracticeClaimICDRecommendationDetails = async (
  payload,
  token
) => {
  try {
    let { data } = await instance({
      url: "practice/getPracticeClaimICDRecommendationDetails",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("getPracticeClaimICDRecommendationDetails", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const getPracticeClaimCPTRecommendationDetails = async (
  payload,
  token
) => {
  try {
    let { data } = await instance({
      url: "practice/getPracticeClaimCPTRecommendationDetails",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("getPracticeClaimCPTRecommendationDetails", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const updatePracticeClaimCPTRecommendationDetails = async (
  payload,
  token
) => {
  try {
    let { data } = await instance({
      url: "practice/updatePracticeClaimCPTRecommendationDetails",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("updatePracticeClaimCPTRecommendationDetails", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const updatePracticeClaimICDRecommendationDetails = async (
  payload,
  token
) => {
  try {
    let { data } = await instance({
      url: "practice/updatePracticeClaimICDRecommendationDetails",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("updatePracticeClaimICDRecommendationDetails", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};

export const deleteManualRecommendationCode = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "practice/deleteManualRecommendationCode",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log("deleteManualRecommendationCode", error);
    throw error;
  }
};

export const getClaimProgressNoteDocument = async (payload, token) => {
  try {
    let { data } = await instance({
      url: "practice/getClaimProgressNoteDocument",
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });
    return data;
  } catch (error) {
    console.log("getClaimProgressNoteDocument", error);
    return {
      message: error?.response?.data,
      code: error?.response?.status,
    };
  }
};
